// @flow

import React, { useEffect, useState } from "react"
import { useIntl } from "react-intl"
import { Link, withRouter } from "react-router-dom"
import styled from "styled-components"
import { Icon } from "antd"
import { PrimaryButton } from "@cabonline/shared/components"
import { HeroPrimary, ParagraphPrimary } from "../../../shared/components/text"
import { colorYellow, gutter, rowGutter } from "shared/utils/design"
import logo from "shared/resources/cabonline1.svg"
import analytics from "shared/utils/services/analytics"
import { ACTIONS } from "shared/constants/gaEvents"
import DriverWebStore from "shared/stores/DriverWebStore"
import LoadingSpin from "shared/components/LoadingSpin"
import AccountAlreadyExist from "./AccountAlreadyExist"
import LanguageSelector from "apps/dashboard/LanguageSelector"

const Logo = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 12px;
  img {
    width: 150px;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: center;
  background: #000;
  color: #fff;
  height: 100%;
  padding-top: 64px;
`
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
`

const TitleWrapper = styled.div`
  text-align: center;
`

const WelcomeMessage = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
  font-size: 16px;
  line-height: 1.63;
  text-align: center;
  color: #ffffff;
`

const ActionArea = styled.div`
  display: flex;
  padding: 12px;
  justify-content: center;
`

const LanguageSelection = styled.div`
  div:first-child {
    top: 12px;
    right: 12px;
  }
`

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
`

type Props = {
  match: Object,
  history: Object
}

const CheckRow = ({ text }) => {
  return (
    <Row style={{ marginBottom: rowGutter }}>
      <Icon
        type="check-circle"
        theme="filled"
        style={{ color: `#${colorYellow}`, marginRight: gutter }}
      />
      <ParagraphPrimary white>{text}</ParagraphPrimary>
    </Row>
  )
}

const Welcome = ({ match, history }: Props) => {
  const { token } = match ? match.params : {}
  const Intl = useIntl()
  const [emailAddress, setEmailAddress] = useState(null)
  const [isChecking, setIsChecking] = useState(true)
  useEffect(() => {
    let isMounted = true
    analytics.startTracking()
    async function checkToken() {
      try {
        const response = await DriverWebStore.getDriverPhoneNumberByToken(token)
        if (response.data.emailAddress && isMounted) {
          setEmailAddress(response.data.emailAddress)
        }
      } catch (e) {
        if (
          e.response &&
          e.response.data.errors &&
          e.response.data.errors[0].code === "PHONE_NUMBER_VERIFICATION_ERROR"
        )
          history.push("/")
      }
      setIsChecking(false)
    }
    checkToken()
    return () => {
      isMounted = false
    }
  }, [])

  if (isChecking) return <LoadingSpin />
  if (emailAddress) return <AccountAlreadyExist emailAddress={emailAddress} />
  else
    return (
      <Container>
        <Logo>
          <img src={logo} alt="Logo" />
        </Logo>
        <LanguageSelection>
          <LanguageSelector theme={"dark"} />
        </LanguageSelection>
        <ContentWrapper>
          <TitleWrapper>
            <HeroPrimary>
              {Intl.formatMessage({ id: "apps.driver-web.onboarding.header" })}
            </HeroPrimary>
          </TitleWrapper>
          <WelcomeMessage>
            <ParagraphPrimary white>
              {Intl.formatMessage({
                id: "apps.driver-web.onboarding.launchText"
              })}
            </ParagraphPrimary>
            <ParagraphPrimary white>
              {Intl.formatMessage({
                id: "apps.driver-web.onboarding.hereYouCan"
              })}
            </ParagraphPrimary>
            <br />
          </WelcomeMessage>
          <Center>
            <CheckRow
              text={Intl.formatMessage({
                id: "apps.driver-web.onboarding.feature.education"
              })}
            />
            <CheckRow
              text={Intl.formatMessage({
                id: "apps.driver-web.onboarding.feature.rating"
              })}
            />
            <CheckRow
              text={Intl.formatMessage({
                id: "apps.driver-web.onboarding.feature.personalInfo"
              })}
            />
            <CheckRow
              text={Intl.formatMessage({
                id: "apps.driver-web.onboarding.feature.news"
              })}
            />
          </Center>
          <ActionArea>
            <Link
              to={`/driver/create-account/${token}`}
              onClick={() => {
                analytics.logInteraction(ACTIONS.DRIVER_CLICK_CREAT_ACCOUNT)
              }}
            >
              <PrimaryButton>
                {Intl.formatMessage({
                  id: "apps.driver-web.onboarding.create"
                })}
              </PrimaryButton>
            </Link>
          </ActionArea>
        </ContentWrapper>
      </Container>
    )
}

export default (withRouter(Welcome): any)
